export default __webpack_public_path__ + "static/media/redmi_note_10_5G_phone.98517642.jpeg";